import { connect } from 'react-redux';
import OCTipoPago from "./OCTipoPago";
import { actions, setVerBuscador } from "../../../../../redux/modules/orden_compra/orden_compra"

const ms2p = (state) => {
    let total = 0;
    state.ordenes_compra.seleccionados.forEach((producto) => {
        const costo = producto.costo ? parseFloat(producto.costo) : 0;
        const cantidad = producto.cantidad ? parseFloat(producto.cantidad) : 0;
        total = total + (costo * cantidad);
    });
    return {
        ...state.ordenes_compra,
        pais: state.usuario.me.pais,
        total,
        conf_tipo_negocio:
        state.configuracion && state.configuracion.config
            ? state.configuracion.config.conf_tipo_negocio
            : false, 
    }
}

const md2p = {
    ...actions,
    setVerBuscador: (estado) => dispatch => dispatch(setVerBuscador(estado)),
};

export default connect(ms2p, md2p)(OCTipoPago);